import { useMutation } from '@tanstack/react-query'
import { api } from '@personic/shared'

export interface EmailPreviewRequest {
  variables?: Record<string, string>
}

export interface EmailPreviewResponse {
  subject: string
  html: string
  text_body: string
  variables_used: string[]
}

export interface EmailTestSendRequest {
  recipients: string[]
  variables?: Record<string, string>
}

export function usePreviewEmailTemplate() {
  return useMutation<EmailPreviewResponse, Error, { emailType: string; variables?: Record<string, string> }>({
    mutationFn: async ({ emailType, variables }) => {
      const res = await api.post(`/admin/templates/${emailType}/preview`, { variables })
      return res.data
    },
  })
}

export function useTestSendEmail() {
  return useMutation<{ success: boolean; message: string; sent_count: number }, Error, { emailType: string; recipients: string[]; variables?: Record<string, string> }>({
    mutationFn: async ({ emailType, recipients, variables }) => {
      const res = await api.post(`/admin/templates/${emailType}/test`, { recipients, variables })
      return res.data
    },
  })
}
